// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.App-header {
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  padding: 2rem;
  position: relative;
  overflow: hidden;
}

.App-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.1);
  z-index: 1;
}

.hero-content {
  z-index: 2;
  position: relative;
}

.App-header h1 {
  font-size: 3.5rem;
  margin: 0 0 0.5rem 0;
  font-weight: 700;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: -0.02em;
}

.App-header h2 {
  font-size: 1.5rem;
  margin: 0 0 1rem 0;
  font-weight: 400;
  opacity: 0.95;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
}

.hero-subtitle {
  font-size: 1.1rem;
  margin: 0 0 2rem 0;
  opacity: 0.9;
  font-weight: 300;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
}

.social-links {
  display: flex;
  gap: 1.5rem;
  margin-top: 2rem;
  z-index: 2;
  position: relative;
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.social-link:hover {
  transform: translateY(-3px);
  background: rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

.social-link svg {
  width: 24px;
  height: 24px;
}

.social-link.linkedin:hover {
  background: rgba(0, 119, 181, 0.2);
  border-color: #0077b5;
}

.social-link.github:hover {
  background: rgba(36, 41, 46, 0.2);
  border-color: #24292e;
}

main {
  background: #f8fafc;
  padding: 0;
}

section {
  padding: 4rem 2rem;
  margin: 0;
  position: relative;
}

section:nth-child(even) {
  background: white;
}

section h2 {
  font-size: 2.5rem;
  color: #1a202c;
  margin-bottom: 2rem;
  text-align: center;
  font-weight: 700;
  position: relative;
}

section h2::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, #667eea, #764ba2);
  border-radius: 2px;
}

section p {
  color: #666;
  line-height: 1.6;
}

.about-section {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.about-content {
  max-width: 1000px;
  margin: 0 auto;
}

.about-intro {
  font-size: 1.2rem;
  color: #2d3748;
  line-height: 1.8;
  margin-bottom: 2rem;
  font-weight: 400;
  text-align: center;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.about-details {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  margin-top: 3rem;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

.about-item {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  padding: 2.5rem;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(102, 126, 234, 0.2);
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
}

.about-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 6px;
  height: 100%;
  background: linear-gradient(180deg, #667eea 0%, #764ba2 100%);
}

.about-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 48px rgba(102, 126, 234, 0.15);
  border-color: rgba(102, 126, 234, 0.4);
}

.about-item h4 {
  color: #1a202c;
  margin-bottom: 1.2rem;
  font-size: 1.4rem;
  font-weight: 700;
  padding-left: 1rem;
}

.about-item p {
  color: #4a5568;
  line-height: 1.7;
  margin: 0;
  font-size: 1.05rem;
  font-weight: 500;
  padding-left: 1rem;
}

.skills-section {
  background: white;
}

.skills-category {
  margin-bottom: 3rem;
}

.skills-category h3 {
  font-size: 1.5rem;
  color: #2d3748;
  margin-bottom: 1.5rem;
  text-align: center;
  font-weight: 600;
}

.skills-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

.skill-item {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  padding: 2rem 1.5rem;
  border-radius: 12px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(102, 126, 234, 0.15);
  transition: all 0.4s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.skill-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #667eea 0%, #764ba2 100%);
}

.skill-item:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 36px rgba(102, 126, 234, 0.12);
  border-color: rgba(102, 126, 234, 0.3);
}

.skill-icon {
  font-size: 2.2rem;
  margin-bottom: 1rem;
  color: #667eea;
  transition: all 0.3s ease;
}

.skill-item:hover .skill-icon {
  color: #764ba2;
  transform: scale(1.1);
}

.skill-icon svg {
  width: 28px;
  height: 28px;
}

.skill-name {
  font-size: 0.9rem;
  color: #2d3748;
  font-weight: 600;
  text-align: center;
  line-height: 1.3;
  transition: color 0.3s ease;
}

.skill-item:hover .skill-name {
  color: #1a202c;
}

.projects-section {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.projects-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
  margin-top: 1.5rem;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.project-card {
  background: white;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.project-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
}

.project-image {
  height: 120px;
  overflow: hidden;
  position: relative;
}

.project-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.project-card:hover .project-image img {
  transform: scale(1.05);
}

.project-content {
  padding: 1rem;
}

.project-content h3 {
  font-size: 1rem;
  color: #1a202c;
  margin-bottom: 0.4rem;
  font-weight: 600;
}

.project-content p {
  color: #4a5568;
  line-height: 1.3;
  margin-bottom: 0.5rem;
  font-size: 0.8rem;
}

.project-highlights {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin-bottom: 0.4rem;
}

.highlight {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  padding: 0.15rem 0.4rem;
  border-radius: 10px;
  font-size: 0.6rem;
  font-weight: 500;
}

.project-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin-bottom: 0.5rem;
}

.tag {
  background: #e2e8f0;
  color: #4a5568;
  padding: 0.15rem 0.4rem;
  border-radius: 3px;
  font-size: 0.6rem;
  font-weight: 500;
}

.project-link {
  display: inline-flex;
  align-items: center;
  color: #667eea;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.75rem;
  transition: color 0.3s ease;
}

.project-link:hover {
  color: #764ba2;
}

.contact-section {
  background: white;
  text-align: center;
}

.contact-content {
  max-width: 600px;
  margin: 0 auto;
}

.contact-content p {
  font-size: 1.1rem;
  color: #4a5568;
  margin-bottom: 2rem;
  line-height: 1.6;
}

.contact-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.contact-btn {
  display: inline-block;
  padding: 1rem 2rem;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.contact-btn.primary {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
}

.contact-btn.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
}

.contact-btn.secondary {
  background: white;
  color: #667eea;
  border-color: #667eea;
}

.contact-btn.secondary:hover {
  background: #667eea;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.2);
}

.projects-showcase {
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid #e2e8f0;
}

.projects-showcase h3 {
  font-size: 1.8rem;
  color: #2d3748;
  margin-bottom: 1.5rem;
  text-align: center;
  font-weight: 600;
  position: relative;
}

.projects-showcase h3::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 3px;
  background: linear-gradient(90deg, #667eea, #764ba2);
  border-radius: 2px;
}

.projects-showcase .projects-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  margin-top: 1.5rem;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
}

.projects-showcase .project-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px solid #f1f5f9;
}

.projects-showcase .project-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
  border-color: #667eea;
}

.projects-showcase .project-image {
  height: 160px;
  overflow: hidden;
  position: relative;
}

.projects-showcase .project-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.projects-showcase .project-card:hover .project-image img {
  transform: scale(1.08);
}

.projects-showcase .project-content {
  padding: 1.5rem;
}

.projects-showcase .project-content h4 {
  font-size: 1.2rem;
  color: #1a202c;
  margin-bottom: 0.75rem;
  font-weight: 600;
}

.projects-showcase .project-content p {
  color: #4a5568;
  line-height: 1.5;
  margin-bottom: 1rem;
  font-size: 0.9rem;
}

.projects-showcase .project-highlights {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-bottom: 0.75rem;
}

.projects-showcase .highlight {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  padding: 0.25rem 0.6rem;
  border-radius: 15px;
  font-size: 0.7rem;
  font-weight: 500;
}

.projects-showcase .project-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-bottom: 1rem;
}

.projects-showcase .tag {
  background: #f8fafc;
  color: #4a5568;
  padding: 0.25rem 0.6rem;
  border-radius: 6px;
  font-size: 0.7rem;
  font-weight: 500;
  border: 1px solid #e2e8f0;
}

.projects-showcase .project-link {
  display: inline-flex;
  align-items: center;
  color: #667eea;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.85rem;
  transition: all 0.3s ease;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.projects-showcase .project-link:hover {
  color: #764ba2;
  background: #667eea;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.hero-email {
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: 500;
  margin-top: 0.5rem;
  margin-bottom: 0;
  text-decoration: none;
  transition: all 0.3s ease;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.hero-email:hover {
  color: #f0f0f0;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
}

/* Responsive Design */
@media (max-width: 768px) {
  .App-header {
    min-height: 50vh;
    padding: 1.5rem;
  }

  .App-header h1 {
    font-size: 2.5rem;
  }

  .App-header h2 {
    font-size: 1.25rem;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  main {
    padding: 0;
  }

  section {
    padding: 2rem 1rem;
  }

  section h2 {
    font-size: 2rem;
  }

  .about-intro {
    font-size: 1rem;
    margin-bottom: 1.5rem;
  }

  .about-details {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    margin-top: 1.5rem;
    align-items: stretch;
  }

  .about-item {
    padding: 1.5rem;
  }

  .about-item h4 {
    font-size: 1.2rem;
    margin-bottom: 0.75rem;
  }

  .about-item p {
    font-size: 0.95rem;
  }

  .skills-category {
    margin-bottom: 2rem;
  }

  .skills-category h3 {
    font-size: 1.3rem;
    margin-bottom: 1rem;
  }

  .skills-grid {
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    gap: 0.75rem;
  }

  .skill-item {
    padding: 0.75rem;
  }

  .skill-icon {
    font-size: 1.75rem;
    margin-bottom: 0.4rem;
  }

  .skill-icon svg {
    width: 20px;
    height: 20px;
  }

  .skill-name {
    font-size: 0.75rem;
  }

  .projects-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
    margin-top: 1rem;
  }

  .project-content {
    padding: 0.75rem;
  }

  .project-content h3 {
    font-size: 0.9rem;
  }

  .project-content p {
    font-size: 0.75rem;
  }

  .highlight {
    font-size: 0.55rem;
    padding: 0.1rem 0.3rem;
  }

  .tag {
    font-size: 0.55rem;
    padding: 0.1rem 0.3rem;
  }

  .project-link {
    font-size: 0.7rem;
  }

  .contact-content p {
    font-size: 1rem;
  }

  .contact-actions {
    flex-direction: column;
    align-items: center;
  }

  .contact-btn {
    width: 100%;
    max-width: 300px;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .App-header {
    padding: 2rem 1rem;
    min-height: 60vh;
  }

  .App-header h1 {
    font-size: 2rem;
    margin-bottom: 0.5rem;
  }

  .App-header h2 {
    font-size: 1rem;
    margin-bottom: 1rem;
  }

  .hero-subtitle {
    font-size: 0.9rem;
    margin-bottom: 1.5rem;
  }

  .social-links {
    gap: 1rem;
  }

  .social-link {
    width: 40px;
    height: 40px;
  }

  .social-link svg {
    width: 20px;
    height: 20px;
  }

  main {
    padding: 2rem 1rem;
  }

  section {
    margin-bottom: 2rem;
  }

  section h2 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

  .about-intro {
    font-size: 0.95rem;
    margin-bottom: 1.25rem;
  }

  .about-details {
    grid-template-columns: 1fr;
    gap: 1rem;
    margin-top: 1rem;
    align-items: stretch;
  }

  .about-item {
    padding: 1.25rem;
  }

  .about-item h4 {
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
  }

  .about-item p {
    font-size: 0.9rem;
  }

  .skills-category {
    margin-bottom: 1.5rem;
  }

  .skills-category h3 {
    font-size: 1.2rem;
    margin-bottom: 0.75rem;
  }

  .skills-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 0.5rem;
  }

  .skill-item {
    padding: 0.5rem;
  }

  .skill-icon {
    font-size: 1.5rem;
    margin-bottom: 0.3rem;
  }

  .skill-icon svg {
    width: 18px;
    height: 18px;
  }

  .skill-name {
    font-size: 0.7rem;
  }

  .projects-showcase .projects-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
    margin-top: 1rem;
  }

  .project-image {
    height: 110px;
  }

  .project-content {
    padding: 0.625rem;
  }

  .project-content h3 {
    font-size: 0.85rem;
  }

  .project-content p {
    font-size: 0.7rem;
  }

  .project-highlights {
    gap: 0.2rem;
  }

  .highlight {
    font-size: 0.5rem;
    padding: 0.1rem 0.25rem;
  }

  .project-tags {
    gap: 0.2rem;
  }

  .tag {
    font-size: 0.5rem;
    padding: 0.1rem 0.25rem;
  }

  .project-link {
    font-size: 0.65rem;
  }

  .contact-content p {
    font-size: 0.95rem;
  }

  .contact-btn {
    padding: 0.875rem 1.5rem;
    font-size: 0.9rem;
  }
}

@media (min-width: 1200px) {
  .projects-grid {
    grid-template-columns: repeat(2, 1fr);
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }

  .projects-showcase .projects-grid {
    grid-template-columns: repeat(2, 1fr);
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
  }

  .skills-grid {
    grid-template-columns: repeat(5, 1fr);
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }

  .about-details {
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
  }

  .contact-content {
    max-width: 700px;
  }
}

@media (max-width: 480px) {
  .projects-showcase {
    margin-top: 1.5rem;
    padding-top: 1rem;
  }

  .projects-showcase h3 {
    font-size: 1.3rem;
    margin-bottom: 0.75rem;
  }

  .projects-showcase .projects-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
    margin-top: 1rem;
  }

  .projects-showcase .project-image {
    height: 140px;
  }

  .projects-showcase .project-content {
    padding: 1rem;
  }

  .projects-showcase .project-content h4 {
    font-size: 1rem;
  }

  .projects-showcase .project-content p {
    font-size: 0.8rem;
  }

  .projects-showcase .project-highlights {
    gap: 0.3rem;
  }

  .projects-showcase .highlight {
    font-size: 0.6rem;
    padding: 0.15rem 0.4rem;
  }

  .projects-showcase .project-tags {
    gap: 0.3rem;
  }

  .projects-showcase .tag {
    font-size: 0.6rem;
    padding: 0.15rem 0.4rem;
  }

  .projects-showcase .project-link {
    font-size: 0.75rem;
    padding: 0.35rem 0.7rem;
  }
}
/* ========== CV (pleine largeur, sans scroll horizontal) ========== */
html {
  scroll-behavior: smooth;
}

@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }
}

/*
 * Scroll vertical sur le document (viewport), pas sur html/body en conteneur :
 * évite double scrollbar, coupes en bas sur mobile, et comportements bizarres iOS.
 */
html,
body,
#root {
  overflow-x: clip;
  overflow-y: visible;
  max-width: 100%;
}

body {
  -webkit-overflow-scrolling: touch;
}

.App.cv-page-root.portfolio-page {
  text-align: left;
  min-height: 100%;
  min-height: 100dvh;
  background: linear-gradient(180deg, #eef2f7 0%, #f8fafc 38%, #f1f5f9 100%);
  color: #0f172a;
  overflow-x: clip;
  overflow-y: visible;
  max-width: 100%;
  font-family: system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  --pf-accent: #2563eb;
  --pf-accent-hover: #1d4ed8;
  --pf-muted: #64748b;
  --pf-border: #e2e8f0;
  --pf-surface: #ffffff;
  --pf-header-bg: #0f172a;
  --pf-header-border: #1e293b;
  --pf-zone-a: #eff6ff;
  --pf-zone-b: #faf5ff;
  --pf-zone-c: #fff7ed;
}

.cv-main-wrap.cv-main-fullpage {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  padding-bottom: 0.5rem;
  background: transparent;
  text-align: left;
  box-sizing: border-box;
  overflow-x: clip;
  overflow-y: visible;
}

.cv-scroll-section {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.cv-theme-band {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.cv-band-inner {
  width: 100%;
  max-width: 72rem;
  margin: 0 auto;
  padding: 2rem 1.25rem;
  box-sizing: border-box;
}

/* En-tête — sobre, centré */
.portfolio-hero.cv-theme-intro {
  min-height: 0;
  display: block;
  background: var(--pf-header-bg);
  border-bottom: 1px solid var(--pf-header-border);
  padding: 1.35rem 0 1.5rem;
  box-shadow: none;
}

.portfolio-hero.cv-theme-intro .cv-band-inner.cv-hero-inner {
  padding: 0 1rem;
}

.cv-hero-inner {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.cv-header.cv-header-hero {
  background: transparent;
  padding: 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  align-items: center;
}

/* Hero : tout centré */
.portfolio-page .portfolio-hero .cv-header.cv-header-hero {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.portfolio-page .portfolio-hero .cv-header-main {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 1 auto;
  min-width: 0;
  width: 100%;
  max-width: none;
}

.portfolio-hero-content {
  width: 100%;
  max-width: 22rem;
  margin: 0 auto;
  text-align: center;
}

.portfolio-page .portfolio-hero .cv-name::after {
  margin-left: auto;
  margin-right: auto;
}

.portfolio-page .portfolio-hero .cv-contact:not(.portfolio-hero-meta) {
  justify-content: center;
  width: 100%;
  max-width: 28rem;
}

.portfolio-page .portfolio-hero .cv-contact:not(.portfolio-hero-meta) li {
  justify-content: center;
}

.portfolio-page .portfolio-hero .cv-contact:not(.portfolio-hero-meta) .cv-contact-block-text {
  align-items: center;
  text-align: center;
}

.cv-header.cv-header-hero::before {
  display: none;
}

.portfolio-hero .portfolio-eyebrow {
  margin: 0 0 0.4rem;
  font-size: 0.65rem;
  font-weight: 500;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #94a3b8;
}

.cv-main-wrap section,
.cv-scroll-section .cv-band-inner section {
  padding: 0 !important;
  margin: 0 !important;
  background: transparent !important;
}

.cv-main-wrap section:nth-child(even),
.cv-scroll-section .cv-band-inner section:nth-child(even) {
  background: transparent !important;
}

.cv-main-wrap section h2,
.cv-scroll-section .cv-band-inner section h2 {
  font-size: inherit;
  margin: 0;
  text-align: left;
  font-weight: inherit;
  color: inherit;
}

.cv-main-wrap section h2::after,
.cv-scroll-section .cv-band-inner section h2::after {
  display: none !important;
}

.cv-main-wrap section h3,
.cv-scroll-section .cv-band-inner section h3 {
  font-size: inherit;
  margin: 0;
  text-align: left;
}

.cv-main-wrap section p,
.cv-scroll-section .cv-band-inner section p {
  margin: 0;
  color: inherit;
  line-height: inherit;
}

.portfolio-page .cv-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  padding: 0;
  background: transparent;
  color: inherit;
  position: relative;
  max-width: 100%;
  box-sizing: border-box;
}

.portfolio-page .cv-header:not(.cv-header-hero)::before {
  display: none;
}

.cv-header-main {
  flex: 1 1;
  min-width: min(100%, 14rem);
  text-align: left;
  position: relative;
  z-index: 1;
}

.portfolio-page .portfolio-hero .cv-name {
  margin: 0;
  font-size: clamp(1.35rem, 4vw, 1.75rem);
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #f8fafc;
  line-height: 1.2;
  text-shadow: none;
}

.portfolio-page .portfolio-hero .cv-name::after {
  content: '';
  display: block;
  width: 2rem;
  height: 1px;
  margin: 0.65rem auto 0;
  background: #334155;
}

.portfolio-page .portfolio-hero .cv-header-socials {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem 0.5rem;
  margin-top: 0.85rem;
  align-items: center;
  justify-content: center;
}

.portfolio-page .portfolio-hero .cv-header-socials .cv-social {
  padding: 0.35rem 0.55rem;
  font-size: 0.78rem;
}

.portfolio-page .portfolio-hero .cv-header-socials .cv-social svg {
  width: 16px;
  height: 16px;
}

.portfolio-page .portfolio-hero .cv-contact {
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 0.75rem;
  text-align: right;
  position: relative;
  z-index: 1;
  min-width: 0;
}

.portfolio-page .portfolio-hero .cv-contact li {
  margin-bottom: 0.25rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.35rem;
  align-items: baseline;
}

.portfolio-page .portfolio-hero .cv-contact .cv-contact-block {
  align-items: flex-start;
  margin-bottom: 0.3rem;
}

.portfolio-page .portfolio-hero .cv-contact .cv-contact-block-icon {
  flex-shrink: 0;
  width: 1.15rem;
  height: 1.15rem;
  margin-top: 0.12rem;
  color: #38bdf8;
}

.portfolio-page .portfolio-hero .cv-contact .cv-contact-block-text {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  gap: 0.06rem;
  min-width: 0;
}

.portfolio-page .portfolio-hero .cv-contact .cv-contact-value {
  color: #e2e8f0;
  font-weight: 500;
  font-size: 0.75rem;
  line-height: 1.35;
}

.portfolio-page .portfolio-hero .cv-contact-label {
  color: #64748b;
  font-size: 0.6rem;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  font-weight: 600;
}

.portfolio-page .portfolio-hero .cv-contact a {
  color: #e2e8f0;
  text-decoration: none;
  font-weight: 500;
  word-break: break-word;
  border-bottom: 1px solid transparent;
  transition: color 0.15s ease, border-color 0.15s ease;
}

.portfolio-page .portfolio-hero .cv-contact a:hover {
  color: #38bdf8;
  border-bottom-color: rgba(56, 189, 248, 0.45);
}

.portfolio-page .portfolio-hero .cv-social {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  color: #cbd5e1;
  text-decoration: none;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  background: transparent;
  transition: color 0.15s ease, background 0.15s ease;
}

.portfolio-page .portfolio-hero .cv-social:hover {
  color: #f8fafc;
  background: rgba(255, 255, 255, 0.06);
}

/* Coordonnées sous le hero — liste centrée, sans cartes */
.portfolio-page .portfolio-hero .cv-contact.portfolio-hero-meta {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  margin: 1.1rem 0 0;
  padding: 1.05rem 0 0;
  border-top: 1px solid rgba(148, 163, 184, 0.18);
  max-width: none;
  width: 100%;
  text-align: center;
}

.portfolio-page .portfolio-hero .cv-contact.portfolio-hero-meta li {
  margin: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 0.45rem;
  padding: 0;
  border: none;
  background: none;
}

.portfolio-page .portfolio-hero .cv-contact.portfolio-hero-meta .cv-contact-block {
  margin: 0;
}

.portfolio-page .portfolio-hero .cv-contact.portfolio-hero-meta .cv-contact-block-icon {
  width: 1.05rem;
  height: 1.05rem;
  margin-top: 0;
  color: #64748b;
}

.portfolio-page .portfolio-hero .cv-contact.portfolio-hero-meta .cv-contact-block-text {
  align-items: center;
  text-align: center;
  gap: 0.08rem;
}

.portfolio-page .portfolio-hero .cv-contact.portfolio-hero-meta .cv-contact-label {
  font-size: 0.6rem;
  letter-spacing: 0.06em;
  color: #64748b;
}

.portfolio-page .portfolio-hero .cv-contact.portfolio-hero-meta .cv-contact-value {
  font-size: 0.8rem;
  font-weight: 500;
  color: #e2e8f0;
  line-height: 1.3;
}

/* Puces compétences + icônes marques */
.portfolio-page .cv-chip-list--icons {
  gap: 0.4rem;
}

.portfolio-page .cv-chip-with-icon {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  list-style: none;
}

.portfolio-page .cv-chip-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 1.35rem;
  height: 1.35rem;
}

.portfolio-page .cv-chip-svg {
  width: 1.1rem;
  height: 1.1rem;
}

/* Expérience pro — plus lisible */
.portfolio-page .cv-section-exp > h2.pf-section-heading {
  margin-bottom: 2.25rem;
}

.portfolio-page .cv-section-exp .cv-job--with-logo {
  --cv-job-logo-size: 2.75rem;
  --cv-job-logo-gap: 0.75rem;
}

.portfolio-page .cv-section-exp .cv-job-title {
  font-size: 1.12rem;
  font-weight: 700;
  color: #0f172a;
}

.portfolio-page .cv-section-exp .cv-job-org {
  font-size: 0.92rem;
}

.portfolio-page .cv-section-exp .cv-job-loc {
  font-size: 0.84rem;
}

.portfolio-page .cv-section-exp .cv-job-dates {
  font-size: 0.85rem;
}

.portfolio-page .cv-section-exp .cv-bullets {
  font-size: 0.92rem;
  line-height: 1.6;
}

/* Projets : grille responsive, jamais plus large que l’écran */
.portfolio-page .cv-theme-projects-band {
  background: linear-gradient(165deg, var(--pf-zone-a) 0%, var(--pf-surface) 55%);
  border-bottom: 1px solid #bfdbfe;
  padding: 4.75rem 0 2.75rem;
  overflow-x: clip;
}

.cv-theme-projects-band .cv-band-inner {
  max-width: 72rem;
  padding: 0 1.25rem;
}

.portfolio-page .cv-theme-projects-band .cv-band-inner {
  padding-top: 0.5rem;
}

.cv-projects-fullwidth.projects-showcase {
  margin-top: 0;
  padding-top: 0;
  border-top: none;
  max-width: 100%;
  overflow-x: clip;
}

.portfolio-page .cv-projects-fullwidth.projects-showcase {
  overflow-x: visible;
}

/* Titres de bandeau (projets, compétences, expérience) — même style */
.portfolio-page h2.pf-section-heading,
.portfolio-page h3.pf-section-heading {
  margin: 0 0 1.65rem;
  padding: 0;
  font-size: clamp(1.55rem, 4.2vw, 2.4rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: #1e293b;
  text-align: center;
  text-transform: none;
  text-shadow: none;
  border-bottom: none;
  position: relative;
}

.portfolio-page h2.pf-section-heading::after,
.portfolio-page h3.pf-section-heading::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: -12px;
  transform: translateX(-50%);
  width: 3rem;
  height: 3px;
  border-radius: 2px;
  background: var(--pf-accent);
}

.portfolio-page .project-content h4 .project-title-tld {
  color: #facc15;
  font-weight: 700;
}

.portfolio-page .project-image--blur {
  overflow: hidden;
}

.portfolio-page .project-image--blur img {
  filter: blur(6px);
  transform: scale(1.06);
}

@media (hover: hover) and (pointer: fine) {
  .portfolio-page .cv-projects-fullwidth.projects-showcase .project-card:hover .project-image--blur img {
    filter: blur(5px);
    transform: scale(1.08);
  }
}

.portfolio-page .cv-projects-fullwidth.projects-showcase .project-card {
  border: 1px solid var(--pf-border);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
  transition: box-shadow 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}

@media (hover: hover) and (pointer: fine) {
  .portfolio-page .cv-projects-fullwidth.projects-showcase .project-card:hover {
    border-color: #bfdbfe;
    box-shadow: 0 10px 28px rgba(37, 99, 235, 0.1);
    transform: translateY(-2px);
  }
}

.portfolio-page .cv-projects-fullwidth.projects-showcase .highlight {
  background: #f1f5f9 !important;
  color: #475569 !important;
}

.portfolio-page .cv-projects-fullwidth.projects-showcase .project-link {
  color: var(--pf-accent);
  border-color: #e2e8f0;
  background: #fff;
}

.portfolio-page .cv-projects-fullwidth.projects-showcase .project-link:hover {
  background: var(--pf-accent) !important;
  color: #fff !important;
  border-color: var(--pf-accent) !important;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.35);
}

.cv-projects-fullwidth.projects-showcase .projects-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 17rem), 1fr));
  gap: 1.25rem;
  margin-top: 0;
  margin-bottom: 0;
  max-width: 72rem;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding: 0;
  box-sizing: border-box;
}

/* Carrousel pleine largeur viewport, flèches sur les bords de l’écran */
.portfolio-page .projects-carousel-fullbleed {
  position: relative;
  width: 100vw;
  max-width: 100vw;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  box-sizing: border-box;
}

/*
 * 100vw inclut souvent la barre de défilement → léger overflow horizontal ;
 * sur petits écrans / tablettes portrait, on reste en 100% pour un scroll page fluide.
 */
@media (max-width: 1024px) {
  .portfolio-page .projects-carousel-fullbleed {
    width: 100%;
    max-width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
}

.portfolio-page .projects-carousel-shell {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  min-height: 1px;
}

.portfolio-page .projects-carousel-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 4;
  width: 2.65rem;
  height: 2.65rem;
  border-radius: 999px;
  border: 1px solid #e2e8f0;
  background: rgba(255, 255, 255, 0.97);
  color: #0f172a;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 14px rgba(15, 23, 42, 0.14);
  transition: border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.portfolio-page .projects-carousel-arrow--prev {
  left: max(0.25rem, env(safe-area-inset-left, 0px));
}

.portfolio-page .projects-carousel-arrow--next {
  right: max(0.25rem, env(safe-area-inset-right, 0px));
}

.portfolio-page .projects-carousel-arrow:hover {
  border-color: var(--pf-accent);
  color: var(--pf-accent);
  box-shadow: 0 4px 16px rgba(37, 99, 235, 0.2);
}

.portfolio-page .projects-carousel-arrow svg {
  width: 1.4rem;
  height: 1.4rem;
}

.portfolio-page .projects-carousel {
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  gap: 1.25rem;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  scroll-padding-inline: 3rem;
  padding: 0.35rem max(3rem, calc(env(safe-area-inset-left, 0px) + 2.75rem))
    0.45rem max(3rem, calc(env(safe-area-inset-right, 0px) + 2.75rem));
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  overscroll-behavior-x: contain;
  touch-action: pan-x pan-y;
}

.portfolio-page .projects-carousel--no-arrows {
  scroll-padding-inline: max(1rem, env(safe-area-inset-left, 0px))
    max(1rem, env(safe-area-inset-right, 0px));
  padding-left: max(1rem, env(safe-area-inset-left, 0px));
  padding-right: max(1rem, env(safe-area-inset-right, 0px));
}

/* Grands écrans : piste centrée quand tout tient sans scroll horizontal */
@media (min-width: 1024px) {
  .portfolio-page .projects-carousel.projects-carousel--no-arrows {
    justify-content: center;
  }
}

/* Espace de fin de piste : dernière carte entièrement visible au scroll */
.portfolio-page .projects-carousel-end-spacer {
  flex: 0 0 min(
      4rem,
      max(1.25rem, calc((100vw - min(19rem, calc(100vw - 5.5rem))) / 2))
    );
  min-width: min(
    4rem,
    max(1.25rem, calc((100vw - min(19rem, calc(100vw - 5.5rem))) / 2))
  );
  height: 1px;
  align-self: stretch;
  pointer-events: none;
  visibility: hidden;
}

.portfolio-page .projects-carousel::-webkit-scrollbar {
  display: none;
}

.portfolio-page .projects-carousel .project-card {
  flex: 0 0 19rem;
  min-width: 19rem;
  max-width: 19rem;
  scroll-snap-align: start;
  display: flex;
  flex-direction: column;
  height: auto;
  align-self: flex-start;
}

@media (max-width: 380px) {
  .portfolio-page .projects-carousel .project-card {
    flex-basis: min(19rem, calc(100vw - 5.75rem));
    min-width: min(19rem, calc(100vw - 5.75rem));
    max-width: min(19rem, calc(100vw - 5.75rem));
  }
}

/* Cartes projets : hauteur au contenu, visuel plus compact */
.portfolio-page .cv-projects-fullwidth.projects-showcase .project-image {
  height: 152px;
  flex-shrink: 0;
}

.portfolio-page .cv-projects-fullwidth.projects-showcase .project-content {
  flex: 0 1 auto;
  padding: 0.85rem 1rem 1.05rem;
  display: flex;
  flex-direction: column;
}

.portfolio-page .cv-projects-fullwidth.projects-showcase .project-content h4 {
  font-size: 1.12rem;
  margin-bottom: 0.45rem;
}

.portfolio-page .cv-projects-fullwidth.projects-showcase .project-content p {
  font-size: 0.86rem;
  line-height: 1.5;
  margin-bottom: 0.6rem;
}

.portfolio-page .cv-projects-fullwidth.projects-showcase .project-highlights {
  margin-bottom: 0.45rem;
}

.portfolio-page .cv-projects-fullwidth.projects-showcase .project-tags {
  margin-bottom: 0.5rem;
}

.portfolio-page .cv-projects-fullwidth.projects-showcase .project-link {
  margin-top: 0;
  align-self: flex-start;
}

@media (max-width: 520px) {
  .portfolio-page .projects-carousel-arrow {
    width: 2.1rem;
    height: 2.1rem;
  }

  .portfolio-page .projects-carousel-arrow svg {
    width: 1.2rem;
    height: 1.2rem;
  }
}

/* Parcours */
.portfolio-page .cv-theme-parcours-band {
  background: linear-gradient(180deg, var(--pf-zone-b) 0%, #f8fafc 45%);
  padding: 2.5rem 0 3rem;
  border-bottom: 1px solid #e9d5ff;
}

.cv-theme-parcours-band .cv-band-inner {
  max-width: 72rem;
}

.portfolio-page .cv-columns-full {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0;
  align-items: start;
  position: relative;
  background: #fff;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 8px 30px rgba(99, 102, 241, 0.08), 0 2px 8px rgba(15, 23, 42, 0.04);
  overflow: hidden;
  max-width: 100%;
}

.portfolio-page .cv-columns-full::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(180deg, #2563eb, #7c3aed);
  border-radius: 14px 0 0 14px;
  z-index: 1;
  pointer-events: none;
}

@media (min-width: 56rem) {
  .portfolio-page .cv-columns-full {
    grid-template-columns: minmax(0, 16rem) minmax(0, 1fr);
  }
}

@media (min-width: 64rem) {
  .portfolio-page .cv-columns-full {
    grid-template-columns: minmax(0, 17.5rem) minmax(0, 1fr);
  }
}

.cv-theme-parcours-band .cv-sidebar {
  background: #f8fafc;
  border-right: 1px solid #e2e8f0;
}

.cv-theme-parcours-band .cv-main {
  background: #fff;
  min-width: 0;
}

/* Formation */
.portfolio-page .cv-theme-formation-band {
  background: linear-gradient(180deg, var(--pf-zone-c) 0%, #fffbeb 35%, #f8fafc 100%);
  padding: 2.5rem 0 3.5rem;
  border-top: 1px solid #fed7aa;
}

.cv-band-formation {
  width: 100%;
  max-width: 72rem;
  margin: 0 auto;
  padding: 0 1.25rem;
  box-sizing: border-box;
}

.cv-band-formation .cv-section-formation-only {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.06);
  padding: 1.75rem 1.5rem 2rem !important;
  max-width: 100%;
  box-sizing: border-box;
}

.portfolio-page .cv-theme-formation-band .cv-section-title {
  color: #0f172a;
  border-bottom-color: var(--pf-accent);
}

.portfolio-page .cv-theme-formation-band .cv-education > li {
  border-bottom-color: #f1f5f9;
}

.portfolio-page .cv-theme-formation-band .cv-edu-years {
  color: var(--pf-accent);
}

.cv-sidebar {
  background: #f8fafc;
  border-right: 1px solid #e2e8f0;
  padding: 1.5rem 1.15rem 1.75rem;
  font-size: 0.8125rem;
  min-width: 0;
}

.cv-side-section {
  margin-bottom: 1.5rem;
}

.portfolio-page .cv-sidebar .cv-side-section {
  margin-bottom: 2rem;
}

.cv-side-section:last-child {
  margin-bottom: 0;
}

.portfolio-page .cv-sidebar .cv-side-section:last-child {
  margin-bottom: 0;
}

.portfolio-page .cv-sidebar .cv-side-section--extra-top {
  padding-top: 1rem;
}

.cv-side-sub {
  margin: 0.75rem 0 0.35rem;
  font-size: 0.68rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.cv-side-sub:first-of-type {
  margin-top: 0;
}

.portfolio-page .cv-sidebar .cv-side-sub {
  margin: 1rem 0 0.45rem;
}

.portfolio-page .cv-sidebar .cv-side-sub:first-of-type {
  margin-top: 0.35rem;
}

.cv-chip-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
}

.cv-chip-list li {
  background: #fff;
  border: 1px solid #e2e8f0;
  padding: 0.2rem 0.45rem;
  border-radius: 6px;
  font-size: 0.72rem;
  color: #334155;
}

.cv-chip-list-dense li {
  font-size: 0.68rem;
}

.cv-side-text {
  margin: 0;
  color: #475569;
  line-height: 1.55;
  font-size: 0.8rem;
}

.portfolio-page .cv-sidebar .cv-side-infra-lead {
  margin-bottom: 0.45rem;
}

.portfolio-page .cv-sidebar .cv-side-cert-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-size: 0.8rem;
  color: #475569;
  line-height: 1.45;
}

.cv-main {
  padding: 1.5rem 1.25rem 2rem;
  text-align: left;
  min-width: 0;
}

.cv-section {
  margin-bottom: 1.5rem;
}

.cv-section:last-child {
  margin-bottom: 0;
}

.portfolio-page .cv-section-title {
  margin: 0 0 0.75rem;
  padding-bottom: 0.35rem;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.11em;
  color: #0f172a;
  border-bottom: 2px solid var(--pf-accent);
}

.portfolio-page .cv-section-title--with-suffix {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.45rem 0.65rem;
}

.portfolio-page .cv-section-title-suffix {
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: none;
  color: #64748b;
}

.cv-job {
  margin-bottom: 1.35rem;
  padding-bottom: 1.35rem;
  border-bottom: 1px solid #e2e8f0;
}

.cv-job:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.cv-job--with-logo {
  --cv-job-logo-size: 2.5rem;
  --cv-job-logo-gap: 0.65rem;
}

.cv-job-block {
  display: flex;
  align-items: flex-start;
  gap: var(--cv-job-logo-gap);
}

.cv-job-logo {
  width: var(--cv-job-logo-size);
  height: var(--cv-job-logo-size);
  flex-shrink: 0;
  object-fit: contain;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 0 0 1px rgba(15, 23, 42, 0.08);
}

.cv-job-block-text {
  flex: 1 1;
  min-width: 0;
}

.cv-job-title-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.5rem 0.85rem;
  margin-bottom: 0.1rem;
}

.cv-job-title-row .cv-job-title {
  flex: 1 1;
  min-width: 0;
}

.cv-job-title {
  margin: 0;
  font-size: 0.98rem;
  font-weight: 600;
  color: #1a202c;
}

.cv-job-org {
  margin: 0.15rem 0 0;
  font-size: 0.84rem;
  font-weight: 500;
  color: #475569;
}

.cv-job-loc {
  margin: 0.1rem 0 0;
  font-size: 0.8rem;
  color: #64748b;
}

.portfolio-page .cv-job-dates {
  flex-shrink: 0;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--pf-accent);
  white-space: nowrap;
}

.cv-bullets {
  margin: 0.5rem 0 0;
  padding-left: 1.1rem;
  color: #4a5568;
  font-size: 0.84rem;
  line-height: 1.55;
}

.cv-job-block-text .cv-bullets {
  margin-top: 0.55rem;
}

.cv-bullets li {
  margin-bottom: 0.3rem;
}

.cv-education {
  list-style: none;
  margin: 0;
  padding: 0;
}

.cv-education > li {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 0.45rem 1rem;
  padding: 0.6rem 0;
  border-bottom: 1px solid #f1f5f9;
  font-size: 0.84rem;
}

.cv-education > li:last-child {
  border-bottom: none;
}

.cv-edu-main {
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
  max-width: 100%;
  min-width: 0;
}

.cv-edu-main strong {
  color: #1a202c;
  font-weight: 600;
}

.cv-edu-main span {
  color: #64748b;
  font-size: 0.8rem;
}

.portfolio-page .cv-edu-years {
  flex-shrink: 0;
  font-weight: 600;
  color: var(--pf-accent);
  font-size: 0.78rem;
}

/* Footer discret + marge basse (encoche / home indicator) */
.portfolio-footer {
  text-align: center;
  padding: 1.1rem 1rem calc(1rem + env(safe-area-inset-bottom, 12px));
  font-size: 0.72rem;
  color: #94a3b8;
  letter-spacing: 0.02em;
  border-top: 1px solid #e2e8f0;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
}

.portfolio-footer p {
  margin: 0;
}

.portfolio-footer-link {
  color: #64748b;
  text-decoration: none;
}

.portfolio-footer-link:hover {
  color: var(--pf-accent);
  text-decoration: underline;
}

@media (max-width: 768px) {
  .portfolio-hero.cv-theme-intro {
    padding: 0.65rem 0 0.85rem;
  }

  .portfolio-page .portfolio-hero .cv-header {
    flex-direction: column;
    align-items: center;
  }

  .portfolio-page .portfolio-hero .cv-header.cv-header-hero {
    padding: 0;
  }

  .portfolio-page .portfolio-hero .cv-contact:not(.portfolio-hero-meta) {
    text-align: center;
    width: 100%;
  }

  .portfolio-page .portfolio-hero .cv-contact:not(.portfolio-hero-meta) li {
    justify-content: center;
  }

  .portfolio-page .portfolio-hero .cv-contact:not(.portfolio-hero-meta) .cv-contact-block-text {
    align-items: center;
    text-align: center;
  }

  .cv-theme-parcours-band .cv-sidebar {
    border-right: none;
    border-bottom: 1px solid #e2e8f0;
  }

  .cv-main {
    padding: 1.25rem 1rem 1.75rem;
  }

  .cv-job-title-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.35rem;
  }

  .portfolio-page .cv-job-dates {
    white-space: normal;
  }
}

@media print {
  .App.cv-page-root.portfolio-page {
    background: #fff;
    overflow: visible;
  }

  .cv-main-wrap {
    background: #fff;
  }

  .cv-theme-band,
  .portfolio-hero.cv-theme-intro {
    background: #fff !important;
    min-height: auto;
    border: none;
    box-shadow: none;
  }

  .cv-job {
    page-break-inside: avoid;
    break-inside: avoid;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,2CAA2C;EAC3C,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;EAC1C,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,eAAe;EACf,mBAAmB;EACnB,yCAAyC;EACzC,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,6DAA6D;AAC/D;;AAEA;EACE,2BAA2B;EAC3B,iDAAiD;EACjD,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,oBAAoB;EACpB,mBAAmB;EACnB,0CAA0C;EAC1C,2CAA2C;EAC3C,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,6DAA6D;AAC/D;;AAEA;EACE,2BAA2B;EAC3B,iDAAiD;EACjD,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;EAC3C,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;IACX,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,2DAA2D;IAC3D,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,qCAAqC;IACrC,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;AACF;AACA,sEAAsE;AACtE;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;;;EAGE;AACF;;;EAGE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,0EAA0E;EAC1E,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,8FAA8F;EAC9F,mCAAmC;EACnC,oBAAoB;EACpB,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,cAAc;EACd,+BAA+B;EAC/B,gDAAgD;EAChD,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,oCAAoC;EACpC,qDAAqD;AACvD;;AAEA;EACE,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,mDAAmD;AACrD;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,+CAA+C;EAC/C,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,+EAA+E;EAC/E,gCAAgC;EAChC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sEAAsE;AACtE;;EAEE,mBAAmB;EACnB,UAAU;EACV,wCAAwC;EACxC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACF;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;EAC5C,6EAA6E;AAC/E;;AAEA;EACE;IACE,qBAAqB;IACrB,8CAA8C;IAC9C,2BAA2B;EAC7B;AACF;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,sBAAsB;EACtB,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sEAAsE;EACtE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,sBAAsB;AACxB;;AAEA,wEAAwE;AACxE;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;;;EAGE;AACF;EACE;IACE,WAAW;IACX,eAAe;IACf,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,4EAA4E;AAC9E;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,2BAA2B;EAC3B;sEACoE;EACpE,sBAAsB;EACtB,iCAAiC;EACjC,qBAAqB;EACrB,wBAAwB;EACxB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE;8CAC4C;EAC5C,uDAAuD;EACvD,yDAAyD;AAC3D;;AAEA,0EAA0E;AAC1E;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA,0EAA0E;AAC1E;EACE;;;KAIG;EACH;;;GAGC;EACD,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE;IACE,6CAA6C;IAC7C,4CAA4C;IAC5C,4CAA4C;EAC9C;AACF;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;AACF;;AAEA,aAAa;AACb;EACE,qEAAqE;EACrE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,MAAM;EACN,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,iFAAiF;EACjF,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,qDAAqD;EACrD,4BAA4B;EAC5B,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE;IACE,sDAAsD;EACxD;AACF;;AAEA;EACE;IACE,wDAAwD;EAC1D;AACF;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA,cAAc;AACd;EACE,mFAAmF;EACnF,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,uCAAuC;EACvC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,+BAA+B;EAC/B,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,mEAAmE;EACnE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,6BAA6B;EAC7B,6DAA6D;AAC/D;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,wBAAmB;IAAnB,mBAAmB;EACrB;AACF","sourcesContent":[".App {\n  text-align: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.App-header {\n  min-height: 60vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  padding: 2rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.App-header::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.1);\n  z-index: 1;\n}\n\n.hero-content {\n  z-index: 2;\n  position: relative;\n}\n\n.App-header h1 {\n  font-size: 3.5rem;\n  margin: 0 0 0.5rem 0;\n  font-weight: 700;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n  letter-spacing: -0.02em;\n}\n\n.App-header h2 {\n  font-size: 1.5rem;\n  margin: 0 0 1rem 0;\n  font-weight: 400;\n  opacity: 0.95;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.hero-subtitle {\n  font-size: 1.1rem;\n  margin: 0 0 2rem 0;\n  opacity: 0.9;\n  font-weight: 300;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.social-links {\n  display: flex;\n  gap: 1.5rem;\n  margin-top: 2rem;\n  z-index: 2;\n  position: relative;\n}\n\n.social-link {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 55px;\n  height: 55px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  color: white;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.social-link:hover {\n  transform: translateY(-3px);\n  background: rgba(255, 255, 255, 0.3);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);\n}\n\n.social-link svg {\n  width: 24px;\n  height: 24px;\n}\n\n.social-link.linkedin:hover {\n  background: rgba(0, 119, 181, 0.2);\n  border-color: #0077b5;\n}\n\n.social-link.github:hover {\n  background: rgba(36, 41, 46, 0.2);\n  border-color: #24292e;\n}\n\nmain {\n  background: #f8fafc;\n  padding: 0;\n}\n\nsection {\n  padding: 4rem 2rem;\n  margin: 0;\n  position: relative;\n}\n\nsection:nth-child(even) {\n  background: white;\n}\n\nsection h2 {\n  font-size: 2.5rem;\n  color: #1a202c;\n  margin-bottom: 2rem;\n  text-align: center;\n  font-weight: 700;\n  position: relative;\n}\n\nsection h2::after {\n  content: '';\n  position: absolute;\n  bottom: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 60px;\n  height: 4px;\n  background: linear-gradient(90deg, #667eea, #764ba2);\n  border-radius: 2px;\n}\n\nsection p {\n  color: #666;\n  line-height: 1.6;\n}\n\n.about-section {\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n}\n\n.about-content {\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.about-intro {\n  font-size: 1.2rem;\n  color: #2d3748;\n  line-height: 1.8;\n  margin-bottom: 2rem;\n  font-weight: 400;\n  text-align: center;\n  max-width: 800px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.about-details {\n  display: flex;\n  flex-direction: column;\n  gap: 2.5rem;\n  margin-top: 3rem;\n  max-width: 700px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.about-item {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  padding: 2.5rem;\n  border-radius: 16px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(102, 126, 234, 0.2);\n  transition: all 0.4s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.about-item::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 6px;\n  height: 100%;\n  background: linear-gradient(180deg, #667eea 0%, #764ba2 100%);\n}\n\n.about-item:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 16px 48px rgba(102, 126, 234, 0.15);\n  border-color: rgba(102, 126, 234, 0.4);\n}\n\n.about-item h4 {\n  color: #1a202c;\n  margin-bottom: 1.2rem;\n  font-size: 1.4rem;\n  font-weight: 700;\n  padding-left: 1rem;\n}\n\n.about-item p {\n  color: #4a5568;\n  line-height: 1.7;\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 500;\n  padding-left: 1rem;\n}\n\n.skills-section {\n  background: white;\n}\n\n.skills-category {\n  margin-bottom: 3rem;\n}\n\n.skills-category h3 {\n  font-size: 1.5rem;\n  color: #2d3748;\n  margin-bottom: 1.5rem;\n  text-align: center;\n  font-weight: 600;\n}\n\n.skills-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 2rem;\n  margin-top: 2rem;\n  max-width: 900px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.skill-item {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  padding: 2rem 1.5rem;\n  border-radius: 12px;\n  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);\n  border: 1px solid rgba(102, 126, 234, 0.15);\n  transition: all 0.4s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.skill-item::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 4px;\n  height: 100%;\n  background: linear-gradient(180deg, #667eea 0%, #764ba2 100%);\n}\n\n.skill-item:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 12px 36px rgba(102, 126, 234, 0.12);\n  border-color: rgba(102, 126, 234, 0.3);\n}\n\n.skill-icon {\n  font-size: 2.2rem;\n  margin-bottom: 1rem;\n  color: #667eea;\n  transition: all 0.3s ease;\n}\n\n.skill-item:hover .skill-icon {\n  color: #764ba2;\n  transform: scale(1.1);\n}\n\n.skill-icon svg {\n  width: 28px;\n  height: 28px;\n}\n\n.skill-name {\n  font-size: 0.9rem;\n  color: #2d3748;\n  font-weight: 600;\n  text-align: center;\n  line-height: 1.3;\n  transition: color 0.3s ease;\n}\n\n.skill-item:hover .skill-name {\n  color: #1a202c;\n}\n\n.projects-section {\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n}\n\n.projects-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1rem;\n  margin-top: 1.5rem;\n  max-width: 1200px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.project-card {\n  background: white;\n  border-radius: 6px;\n  overflow: hidden;\n  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.06);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.project-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);\n}\n\n.project-image {\n  height: 120px;\n  overflow: hidden;\n  position: relative;\n}\n\n.project-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.project-card:hover .project-image img {\n  transform: scale(1.05);\n}\n\n.project-content {\n  padding: 1rem;\n}\n\n.project-content h3 {\n  font-size: 1rem;\n  color: #1a202c;\n  margin-bottom: 0.4rem;\n  font-weight: 600;\n}\n\n.project-content p {\n  color: #4a5568;\n  line-height: 1.3;\n  margin-bottom: 0.5rem;\n  font-size: 0.8rem;\n}\n\n.project-highlights {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.25rem;\n  margin-bottom: 0.4rem;\n}\n\n.highlight {\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  color: white;\n  padding: 0.15rem 0.4rem;\n  border-radius: 10px;\n  font-size: 0.6rem;\n  font-weight: 500;\n}\n\n.project-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.25rem;\n  margin-bottom: 0.5rem;\n}\n\n.tag {\n  background: #e2e8f0;\n  color: #4a5568;\n  padding: 0.15rem 0.4rem;\n  border-radius: 3px;\n  font-size: 0.6rem;\n  font-weight: 500;\n}\n\n.project-link {\n  display: inline-flex;\n  align-items: center;\n  color: #667eea;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 0.75rem;\n  transition: color 0.3s ease;\n}\n\n.project-link:hover {\n  color: #764ba2;\n}\n\n.contact-section {\n  background: white;\n  text-align: center;\n}\n\n.contact-content {\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.contact-content p {\n  font-size: 1.1rem;\n  color: #4a5568;\n  margin-bottom: 2rem;\n  line-height: 1.6;\n}\n\n.contact-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.contact-btn {\n  display: inline-block;\n  padding: 1rem 2rem;\n  border-radius: 8px;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  border: 2px solid transparent;\n}\n\n.contact-btn.primary {\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  color: white;\n}\n\n.contact-btn.primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);\n}\n\n.contact-btn.secondary {\n  background: white;\n  color: #667eea;\n  border-color: #667eea;\n}\n\n.contact-btn.secondary:hover {\n  background: #667eea;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.2);\n}\n\n.projects-showcase {\n  margin-top: 3rem;\n  padding-top: 2rem;\n  border-top: 1px solid #e2e8f0;\n}\n\n.projects-showcase h3 {\n  font-size: 1.8rem;\n  color: #2d3748;\n  margin-bottom: 1.5rem;\n  text-align: center;\n  font-weight: 600;\n  position: relative;\n}\n\n.projects-showcase h3::after {\n  content: '';\n  position: absolute;\n  bottom: -8px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 40px;\n  height: 3px;\n  background: linear-gradient(90deg, #667eea, #764ba2);\n  border-radius: 2px;\n}\n\n.projects-showcase .projects-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1.5rem;\n  margin-top: 1.5rem;\n  max-width: 1000px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.projects-showcase .project-card {\n  background: white;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  transition: all 0.3s ease;\n  border: 1px solid #f1f5f9;\n}\n\n.projects-showcase .project-card:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);\n  border-color: #667eea;\n}\n\n.projects-showcase .project-image {\n  height: 160px;\n  overflow: hidden;\n  position: relative;\n}\n\n.projects-showcase .project-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.projects-showcase .project-card:hover .project-image img {\n  transform: scale(1.08);\n}\n\n.projects-showcase .project-content {\n  padding: 1.5rem;\n}\n\n.projects-showcase .project-content h4 {\n  font-size: 1.2rem;\n  color: #1a202c;\n  margin-bottom: 0.75rem;\n  font-weight: 600;\n}\n\n.projects-showcase .project-content p {\n  color: #4a5568;\n  line-height: 1.5;\n  margin-bottom: 1rem;\n  font-size: 0.9rem;\n}\n\n.projects-showcase .project-highlights {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  margin-bottom: 0.75rem;\n}\n\n.projects-showcase .highlight {\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  color: white;\n  padding: 0.25rem 0.6rem;\n  border-radius: 15px;\n  font-size: 0.7rem;\n  font-weight: 500;\n}\n\n.projects-showcase .project-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  margin-bottom: 1rem;\n}\n\n.projects-showcase .tag {\n  background: #f8fafc;\n  color: #4a5568;\n  padding: 0.25rem 0.6rem;\n  border-radius: 6px;\n  font-size: 0.7rem;\n  font-weight: 500;\n  border: 1px solid #e2e8f0;\n}\n\n.projects-showcase .project-link {\n  display: inline-flex;\n  align-items: center;\n  color: #667eea;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 0.85rem;\n  transition: all 0.3s ease;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n}\n\n.projects-showcase .project-link:hover {\n  color: #764ba2;\n  background: #667eea;\n  color: white;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.hero-email {\n  color: #ffffff;\n  font-size: 1.1rem;\n  font-weight: 500;\n  margin-top: 0.5rem;\n  margin-bottom: 0;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n.hero-email:hover {\n  color: #f0f0f0;\n  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .App-header {\n    min-height: 50vh;\n    padding: 1.5rem;\n  }\n\n  .App-header h1 {\n    font-size: 2.5rem;\n  }\n\n  .App-header h2 {\n    font-size: 1.25rem;\n  }\n\n  .hero-subtitle {\n    font-size: 1rem;\n  }\n\n  main {\n    padding: 0;\n  }\n\n  section {\n    padding: 2rem 1rem;\n  }\n\n  section h2 {\n    font-size: 2rem;\n  }\n\n  .about-intro {\n    font-size: 1rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .about-details {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n    margin-top: 1.5rem;\n    align-items: stretch;\n  }\n\n  .about-item {\n    padding: 1.5rem;\n  }\n\n  .about-item h4 {\n    font-size: 1.2rem;\n    margin-bottom: 0.75rem;\n  }\n\n  .about-item p {\n    font-size: 0.95rem;\n  }\n\n  .skills-category {\n    margin-bottom: 2rem;\n  }\n\n  .skills-category h3 {\n    font-size: 1.3rem;\n    margin-bottom: 1rem;\n  }\n\n  .skills-grid {\n    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));\n    gap: 0.75rem;\n  }\n\n  .skill-item {\n    padding: 0.75rem;\n  }\n\n  .skill-icon {\n    font-size: 1.75rem;\n    margin-bottom: 0.4rem;\n  }\n\n  .skill-icon svg {\n    width: 20px;\n    height: 20px;\n  }\n\n  .skill-name {\n    font-size: 0.75rem;\n  }\n\n  .projects-grid {\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n    margin-top: 1rem;\n  }\n\n  .project-content {\n    padding: 0.75rem;\n  }\n\n  .project-content h3 {\n    font-size: 0.9rem;\n  }\n\n  .project-content p {\n    font-size: 0.75rem;\n  }\n\n  .highlight {\n    font-size: 0.55rem;\n    padding: 0.1rem 0.3rem;\n  }\n\n  .tag {\n    font-size: 0.55rem;\n    padding: 0.1rem 0.3rem;\n  }\n\n  .project-link {\n    font-size: 0.7rem;\n  }\n\n  .contact-content p {\n    font-size: 1rem;\n  }\n\n  .contact-actions {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .contact-btn {\n    width: 100%;\n    max-width: 300px;\n    text-align: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .App-header {\n    padding: 2rem 1rem;\n    min-height: 60vh;\n  }\n\n  .App-header h1 {\n    font-size: 2rem;\n    margin-bottom: 0.5rem;\n  }\n\n  .App-header h2 {\n    font-size: 1rem;\n    margin-bottom: 1rem;\n  }\n\n  .hero-subtitle {\n    font-size: 0.9rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .social-links {\n    gap: 1rem;\n  }\n\n  .social-link {\n    width: 40px;\n    height: 40px;\n  }\n\n  .social-link svg {\n    width: 20px;\n    height: 20px;\n  }\n\n  main {\n    padding: 2rem 1rem;\n  }\n\n  section {\n    margin-bottom: 2rem;\n  }\n\n  section h2 {\n    font-size: 1.5rem;\n    margin-bottom: 1rem;\n  }\n\n  .about-intro {\n    font-size: 0.95rem;\n    margin-bottom: 1.25rem;\n  }\n\n  .about-details {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n    margin-top: 1rem;\n    align-items: stretch;\n  }\n\n  .about-item {\n    padding: 1.25rem;\n  }\n\n  .about-item h4 {\n    font-size: 1.1rem;\n    margin-bottom: 0.5rem;\n  }\n\n  .about-item p {\n    font-size: 0.9rem;\n  }\n\n  .skills-category {\n    margin-bottom: 1.5rem;\n  }\n\n  .skills-category h3 {\n    font-size: 1.2rem;\n    margin-bottom: 0.75rem;\n  }\n\n  .skills-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 0.5rem;\n  }\n\n  .skill-item {\n    padding: 0.5rem;\n  }\n\n  .skill-icon {\n    font-size: 1.5rem;\n    margin-bottom: 0.3rem;\n  }\n\n  .skill-icon svg {\n    width: 18px;\n    height: 18px;\n  }\n\n  .skill-name {\n    font-size: 0.7rem;\n  }\n\n  .projects-showcase .projects-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n    margin-top: 1rem;\n  }\n\n  .project-image {\n    height: 110px;\n  }\n\n  .project-content {\n    padding: 0.625rem;\n  }\n\n  .project-content h3 {\n    font-size: 0.85rem;\n  }\n\n  .project-content p {\n    font-size: 0.7rem;\n  }\n\n  .project-highlights {\n    gap: 0.2rem;\n  }\n\n  .highlight {\n    font-size: 0.5rem;\n    padding: 0.1rem 0.25rem;\n  }\n\n  .project-tags {\n    gap: 0.2rem;\n  }\n\n  .tag {\n    font-size: 0.5rem;\n    padding: 0.1rem 0.25rem;\n  }\n\n  .project-link {\n    font-size: 0.65rem;\n  }\n\n  .contact-content p {\n    font-size: 0.95rem;\n  }\n\n  .contact-btn {\n    padding: 0.875rem 1.5rem;\n    font-size: 0.9rem;\n  }\n}\n\n@media (min-width: 1200px) {\n  .projects-grid {\n    grid-template-columns: repeat(2, 1fr);\n    max-width: 1200px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .projects-showcase .projects-grid {\n    grid-template-columns: repeat(2, 1fr);\n    max-width: 1000px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .skills-grid {\n    grid-template-columns: repeat(5, 1fr);\n    max-width: 800px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .about-details {\n    max-width: 1000px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .contact-content {\n    max-width: 700px;\n  }\n}\n\n@media (max-width: 480px) {\n  .projects-showcase {\n    margin-top: 1.5rem;\n    padding-top: 1rem;\n  }\n\n  .projects-showcase h3 {\n    font-size: 1.3rem;\n    margin-bottom: 0.75rem;\n  }\n\n  .projects-showcase .projects-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n    margin-top: 1rem;\n  }\n\n  .projects-showcase .project-image {\n    height: 140px;\n  }\n\n  .projects-showcase .project-content {\n    padding: 1rem;\n  }\n\n  .projects-showcase .project-content h4 {\n    font-size: 1rem;\n  }\n\n  .projects-showcase .project-content p {\n    font-size: 0.8rem;\n  }\n\n  .projects-showcase .project-highlights {\n    gap: 0.3rem;\n  }\n\n  .projects-showcase .highlight {\n    font-size: 0.6rem;\n    padding: 0.15rem 0.4rem;\n  }\n\n  .projects-showcase .project-tags {\n    gap: 0.3rem;\n  }\n\n  .projects-showcase .tag {\n    font-size: 0.6rem;\n    padding: 0.15rem 0.4rem;\n  }\n\n  .projects-showcase .project-link {\n    font-size: 0.75rem;\n    padding: 0.35rem 0.7rem;\n  }\n}\n/* ========== CV (pleine largeur, sans scroll horizontal) ========== */\nhtml {\n  scroll-behavior: smooth;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html {\n    scroll-behavior: auto;\n  }\n}\n\n/*\n * Scroll vertical sur le document (viewport), pas sur html/body en conteneur :\n * évite double scrollbar, coupes en bas sur mobile, et comportements bizarres iOS.\n */\nhtml,\nbody,\n#root {\n  overflow-x: clip;\n  overflow-y: visible;\n  max-width: 100%;\n}\n\nbody {\n  -webkit-overflow-scrolling: touch;\n}\n\n.App.cv-page-root.portfolio-page {\n  text-align: left;\n  min-height: 100%;\n  min-height: 100dvh;\n  background: linear-gradient(180deg, #eef2f7 0%, #f8fafc 38%, #f1f5f9 100%);\n  color: #0f172a;\n  overflow-x: clip;\n  overflow-y: visible;\n  max-width: 100%;\n  font-family: system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  --pf-accent: #2563eb;\n  --pf-accent-hover: #1d4ed8;\n  --pf-muted: #64748b;\n  --pf-border: #e2e8f0;\n  --pf-surface: #ffffff;\n  --pf-header-bg: #0f172a;\n  --pf-header-border: #1e293b;\n  --pf-zone-a: #eff6ff;\n  --pf-zone-b: #faf5ff;\n  --pf-zone-c: #fff7ed;\n}\n\n.cv-main-wrap.cv-main-fullpage {\n  width: 100%;\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n  padding-bottom: 0.5rem;\n  background: transparent;\n  text-align: left;\n  box-sizing: border-box;\n  overflow-x: clip;\n  overflow-y: visible;\n}\n\n.cv-scroll-section {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.cv-theme-band {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.cv-band-inner {\n  width: 100%;\n  max-width: 72rem;\n  margin: 0 auto;\n  padding: 2rem 1.25rem;\n  box-sizing: border-box;\n}\n\n/* En-tête — sobre, centré */\n.portfolio-hero.cv-theme-intro {\n  min-height: 0;\n  display: block;\n  background: var(--pf-header-bg);\n  border-bottom: 1px solid var(--pf-header-border);\n  padding: 1.35rem 0 1.5rem;\n  box-shadow: none;\n}\n\n.portfolio-hero.cv-theme-intro .cv-band-inner.cv-hero-inner {\n  padding: 0 1rem;\n}\n\n.cv-hero-inner {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.cv-header.cv-header-hero {\n  background: transparent;\n  padding: 0;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  align-items: center;\n}\n\n/* Hero : tout centré */\n.portfolio-page .portfolio-hero .cv-header.cv-header-hero {\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.portfolio-page .portfolio-hero .cv-header-main {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 0 1 auto;\n  min-width: 0;\n  width: 100%;\n  max-width: none;\n}\n\n.portfolio-hero-content {\n  width: 100%;\n  max-width: 22rem;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.portfolio-page .portfolio-hero .cv-name::after {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.portfolio-page .portfolio-hero .cv-contact:not(.portfolio-hero-meta) {\n  justify-content: center;\n  width: 100%;\n  max-width: 28rem;\n}\n\n.portfolio-page .portfolio-hero .cv-contact:not(.portfolio-hero-meta) li {\n  justify-content: center;\n}\n\n.portfolio-page .portfolio-hero .cv-contact:not(.portfolio-hero-meta) .cv-contact-block-text {\n  align-items: center;\n  text-align: center;\n}\n\n.cv-header.cv-header-hero::before {\n  display: none;\n}\n\n.portfolio-hero .portfolio-eyebrow {\n  margin: 0 0 0.4rem;\n  font-size: 0.65rem;\n  font-weight: 500;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.cv-main-wrap section,\n.cv-scroll-section .cv-band-inner section {\n  padding: 0 !important;\n  margin: 0 !important;\n  background: transparent !important;\n}\n\n.cv-main-wrap section:nth-child(even),\n.cv-scroll-section .cv-band-inner section:nth-child(even) {\n  background: transparent !important;\n}\n\n.cv-main-wrap section h2,\n.cv-scroll-section .cv-band-inner section h2 {\n  font-size: inherit;\n  margin: 0;\n  text-align: left;\n  font-weight: inherit;\n  color: inherit;\n}\n\n.cv-main-wrap section h2::after,\n.cv-scroll-section .cv-band-inner section h2::after {\n  display: none !important;\n}\n\n.cv-main-wrap section h3,\n.cv-scroll-section .cv-band-inner section h3 {\n  font-size: inherit;\n  margin: 0;\n  text-align: left;\n}\n\n.cv-main-wrap section p,\n.cv-scroll-section .cv-band-inner section p {\n  margin: 0;\n  color: inherit;\n  line-height: inherit;\n}\n\n.portfolio-page .cv-header {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 1rem;\n  padding: 0;\n  background: transparent;\n  color: inherit;\n  position: relative;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.portfolio-page .cv-header:not(.cv-header-hero)::before {\n  display: none;\n}\n\n.cv-header-main {\n  flex: 1;\n  min-width: min(100%, 14rem);\n  text-align: left;\n  position: relative;\n  z-index: 1;\n}\n\n.portfolio-page .portfolio-hero .cv-name {\n  margin: 0;\n  font-size: clamp(1.35rem, 4vw, 1.75rem);\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #f8fafc;\n  line-height: 1.2;\n  text-shadow: none;\n}\n\n.portfolio-page .portfolio-hero .cv-name::after {\n  content: '';\n  display: block;\n  width: 2rem;\n  height: 1px;\n  margin: 0.65rem auto 0;\n  background: #334155;\n}\n\n.portfolio-page .portfolio-hero .cv-header-socials {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.25rem 0.5rem;\n  margin-top: 0.85rem;\n  align-items: center;\n  justify-content: center;\n}\n\n.portfolio-page .portfolio-hero .cv-header-socials .cv-social {\n  padding: 0.35rem 0.55rem;\n  font-size: 0.78rem;\n}\n\n.portfolio-page .portfolio-hero .cv-header-socials .cv-social svg {\n  width: 16px;\n  height: 16px;\n}\n\n.portfolio-page .portfolio-hero .cv-contact {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  font-size: 0.75rem;\n  text-align: right;\n  position: relative;\n  z-index: 1;\n  min-width: 0;\n}\n\n.portfolio-page .portfolio-hero .cv-contact li {\n  margin-bottom: 0.25rem;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 0.35rem;\n  align-items: baseline;\n}\n\n.portfolio-page .portfolio-hero .cv-contact .cv-contact-block {\n  align-items: flex-start;\n  margin-bottom: 0.3rem;\n}\n\n.portfolio-page .portfolio-hero .cv-contact .cv-contact-block-icon {\n  flex-shrink: 0;\n  width: 1.15rem;\n  height: 1.15rem;\n  margin-top: 0.12rem;\n  color: #38bdf8;\n}\n\n.portfolio-page .portfolio-hero .cv-contact .cv-contact-block-text {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  text-align: right;\n  gap: 0.06rem;\n  min-width: 0;\n}\n\n.portfolio-page .portfolio-hero .cv-contact .cv-contact-value {\n  color: #e2e8f0;\n  font-weight: 500;\n  font-size: 0.75rem;\n  line-height: 1.35;\n}\n\n.portfolio-page .portfolio-hero .cv-contact-label {\n  color: #64748b;\n  font-size: 0.6rem;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  font-weight: 600;\n}\n\n.portfolio-page .portfolio-hero .cv-contact a {\n  color: #e2e8f0;\n  text-decoration: none;\n  font-weight: 500;\n  word-break: break-word;\n  border-bottom: 1px solid transparent;\n  transition: color 0.15s ease, border-color 0.15s ease;\n}\n\n.portfolio-page .portfolio-hero .cv-contact a:hover {\n  color: #38bdf8;\n  border-bottom-color: rgba(56, 189, 248, 0.45);\n}\n\n.portfolio-page .portfolio-hero .cv-social {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  color: #cbd5e1;\n  text-decoration: none;\n  font-weight: 500;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  transition: color 0.15s ease, background 0.15s ease;\n}\n\n.portfolio-page .portfolio-hero .cv-social:hover {\n  color: #f8fafc;\n  background: rgba(255, 255, 255, 0.06);\n}\n\n/* Coordonnées sous le hero — liste centrée, sans cartes */\n.portfolio-page .portfolio-hero .cv-contact.portfolio-hero-meta {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.75rem;\n  margin: 1.1rem 0 0;\n  padding: 1.05rem 0 0;\n  border-top: 1px solid rgba(148, 163, 184, 0.18);\n  max-width: none;\n  width: 100%;\n  text-align: center;\n}\n\n.portfolio-page .portfolio-hero .cv-contact.portfolio-hero-meta li {\n  margin: 0;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0;\n  border: none;\n  background: none;\n}\n\n.portfolio-page .portfolio-hero .cv-contact.portfolio-hero-meta .cv-contact-block {\n  margin: 0;\n}\n\n.portfolio-page .portfolio-hero .cv-contact.portfolio-hero-meta .cv-contact-block-icon {\n  width: 1.05rem;\n  height: 1.05rem;\n  margin-top: 0;\n  color: #64748b;\n}\n\n.portfolio-page .portfolio-hero .cv-contact.portfolio-hero-meta .cv-contact-block-text {\n  align-items: center;\n  text-align: center;\n  gap: 0.08rem;\n}\n\n.portfolio-page .portfolio-hero .cv-contact.portfolio-hero-meta .cv-contact-label {\n  font-size: 0.6rem;\n  letter-spacing: 0.06em;\n  color: #64748b;\n}\n\n.portfolio-page .portfolio-hero .cv-contact.portfolio-hero-meta .cv-contact-value {\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: #e2e8f0;\n  line-height: 1.3;\n}\n\n/* Puces compétences + icônes marques */\n.portfolio-page .cv-chip-list--icons {\n  gap: 0.4rem;\n}\n\n.portfolio-page .cv-chip-with-icon {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  list-style: none;\n}\n\n.portfolio-page .cv-chip-icon-wrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 1.35rem;\n  height: 1.35rem;\n}\n\n.portfolio-page .cv-chip-svg {\n  width: 1.1rem;\n  height: 1.1rem;\n}\n\n/* Expérience pro — plus lisible */\n.portfolio-page .cv-section-exp > h2.pf-section-heading {\n  margin-bottom: 2.25rem;\n}\n\n.portfolio-page .cv-section-exp .cv-job--with-logo {\n  --cv-job-logo-size: 2.75rem;\n  --cv-job-logo-gap: 0.75rem;\n}\n\n.portfolio-page .cv-section-exp .cv-job-title {\n  font-size: 1.12rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.portfolio-page .cv-section-exp .cv-job-org {\n  font-size: 0.92rem;\n}\n\n.portfolio-page .cv-section-exp .cv-job-loc {\n  font-size: 0.84rem;\n}\n\n.portfolio-page .cv-section-exp .cv-job-dates {\n  font-size: 0.85rem;\n}\n\n.portfolio-page .cv-section-exp .cv-bullets {\n  font-size: 0.92rem;\n  line-height: 1.6;\n}\n\n/* Projets : grille responsive, jamais plus large que l’écran */\n.portfolio-page .cv-theme-projects-band {\n  background: linear-gradient(165deg, var(--pf-zone-a) 0%, var(--pf-surface) 55%);\n  border-bottom: 1px solid #bfdbfe;\n  padding: 4.75rem 0 2.75rem;\n  overflow-x: clip;\n}\n\n.cv-theme-projects-band .cv-band-inner {\n  max-width: 72rem;\n  padding: 0 1.25rem;\n}\n\n.portfolio-page .cv-theme-projects-band .cv-band-inner {\n  padding-top: 0.5rem;\n}\n\n.cv-projects-fullwidth.projects-showcase {\n  margin-top: 0;\n  padding-top: 0;\n  border-top: none;\n  max-width: 100%;\n  overflow-x: clip;\n}\n\n.portfolio-page .cv-projects-fullwidth.projects-showcase {\n  overflow-x: visible;\n}\n\n/* Titres de bandeau (projets, compétences, expérience) — même style */\n.portfolio-page h2.pf-section-heading,\n.portfolio-page h3.pf-section-heading {\n  margin: 0 0 1.65rem;\n  padding: 0;\n  font-size: clamp(1.55rem, 4.2vw, 2.4rem);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  color: #1e293b;\n  text-align: center;\n  text-transform: none;\n  text-shadow: none;\n  border-bottom: none;\n  position: relative;\n}\n\n.portfolio-page h2.pf-section-heading::after,\n.portfolio-page h3.pf-section-heading::after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  bottom: -12px;\n  transform: translateX(-50%);\n  width: 3rem;\n  height: 3px;\n  border-radius: 2px;\n  background: var(--pf-accent);\n}\n\n.portfolio-page .project-content h4 .project-title-tld {\n  color: #facc15;\n  font-weight: 700;\n}\n\n.portfolio-page .project-image--blur {\n  overflow: hidden;\n}\n\n.portfolio-page .project-image--blur img {\n  filter: blur(6px);\n  transform: scale(1.06);\n}\n\n@media (hover: hover) and (pointer: fine) {\n  .portfolio-page .cv-projects-fullwidth.projects-showcase .project-card:hover .project-image--blur img {\n    filter: blur(5px);\n    transform: scale(1.08);\n  }\n}\n\n.portfolio-page .cv-projects-fullwidth.projects-showcase .project-card {\n  border: 1px solid var(--pf-border);\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);\n  transition: box-shadow 0.2s ease, border-color 0.2s ease, transform 0.2s ease;\n}\n\n@media (hover: hover) and (pointer: fine) {\n  .portfolio-page .cv-projects-fullwidth.projects-showcase .project-card:hover {\n    border-color: #bfdbfe;\n    box-shadow: 0 10px 28px rgba(37, 99, 235, 0.1);\n    transform: translateY(-2px);\n  }\n}\n\n.portfolio-page .cv-projects-fullwidth.projects-showcase .highlight {\n  background: #f1f5f9 !important;\n  color: #475569 !important;\n}\n\n.portfolio-page .cv-projects-fullwidth.projects-showcase .project-link {\n  color: var(--pf-accent);\n  border-color: #e2e8f0;\n  background: #fff;\n}\n\n.portfolio-page .cv-projects-fullwidth.projects-showcase .project-link:hover {\n  background: var(--pf-accent) !important;\n  color: #fff !important;\n  border-color: var(--pf-accent) !important;\n  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.35);\n}\n\n.cv-projects-fullwidth.projects-showcase .projects-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(100%, 17rem), 1fr));\n  gap: 1.25rem;\n  margin-top: 0;\n  margin-bottom: 0;\n  max-width: 72rem;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* Carrousel pleine largeur viewport, flèches sur les bords de l’écran */\n.portfolio-page .projects-carousel-fullbleed {\n  position: relative;\n  width: 100vw;\n  max-width: 100vw;\n  margin-left: calc(50% - 50vw);\n  margin-right: calc(50% - 50vw);\n  box-sizing: border-box;\n}\n\n/*\n * 100vw inclut souvent la barre de défilement → léger overflow horizontal ;\n * sur petits écrans / tablettes portrait, on reste en 100% pour un scroll page fluide.\n */\n@media (max-width: 1024px) {\n  .portfolio-page .projects-carousel-fullbleed {\n    width: 100%;\n    max-width: 100%;\n    margin-left: 0;\n    margin-right: 0;\n  }\n}\n\n.portfolio-page .projects-carousel-shell {\n  position: relative;\n  width: 100%;\n  box-sizing: border-box;\n  min-height: 1px;\n}\n\n.portfolio-page .projects-carousel-arrow {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 4;\n  width: 2.65rem;\n  height: 2.65rem;\n  border-radius: 999px;\n  border: 1px solid #e2e8f0;\n  background: rgba(255, 255, 255, 0.97);\n  color: #0f172a;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 14px rgba(15, 23, 42, 0.14);\n  transition: border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.portfolio-page .projects-carousel-arrow--prev {\n  left: max(0.25rem, env(safe-area-inset-left, 0px));\n}\n\n.portfolio-page .projects-carousel-arrow--next {\n  right: max(0.25rem, env(safe-area-inset-right, 0px));\n}\n\n.portfolio-page .projects-carousel-arrow:hover {\n  border-color: var(--pf-accent);\n  color: var(--pf-accent);\n  box-shadow: 0 4px 16px rgba(37, 99, 235, 0.2);\n}\n\n.portfolio-page .projects-carousel-arrow svg {\n  width: 1.4rem;\n  height: 1.4rem;\n}\n\n.portfolio-page .projects-carousel {\n  width: 100%;\n  min-width: 0;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: flex-start;\n  gap: 1.25rem;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scroll-snap-type: x mandatory;\n  scroll-padding-inline: 3rem;\n  padding: 0.35rem max(3rem, calc(env(safe-area-inset-left, 0px) + 2.75rem))\n    0.45rem max(3rem, calc(env(safe-area-inset-right, 0px) + 2.75rem));\n  box-sizing: border-box;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  overscroll-behavior-x: contain;\n  touch-action: pan-x pan-y;\n}\n\n.portfolio-page .projects-carousel--no-arrows {\n  scroll-padding-inline: max(1rem, env(safe-area-inset-left, 0px))\n    max(1rem, env(safe-area-inset-right, 0px));\n  padding-left: max(1rem, env(safe-area-inset-left, 0px));\n  padding-right: max(1rem, env(safe-area-inset-right, 0px));\n}\n\n/* Grands écrans : piste centrée quand tout tient sans scroll horizontal */\n@media (min-width: 1024px) {\n  .portfolio-page .projects-carousel.projects-carousel--no-arrows {\n    justify-content: center;\n  }\n}\n\n/* Espace de fin de piste : dernière carte entièrement visible au scroll */\n.portfolio-page .projects-carousel-end-spacer {\n  flex: 0 0\n    min(\n      4rem,\n      max(1.25rem, calc((100vw - min(19rem, calc(100vw - 5.5rem))) / 2))\n    );\n  min-width: min(\n    4rem,\n    max(1.25rem, calc((100vw - min(19rem, calc(100vw - 5.5rem))) / 2))\n  );\n  height: 1px;\n  align-self: stretch;\n  pointer-events: none;\n  visibility: hidden;\n}\n\n.portfolio-page .projects-carousel::-webkit-scrollbar {\n  display: none;\n}\n\n.portfolio-page .projects-carousel .project-card {\n  flex: 0 0 19rem;\n  min-width: 19rem;\n  max-width: 19rem;\n  scroll-snap-align: start;\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  align-self: flex-start;\n}\n\n@media (max-width: 380px) {\n  .portfolio-page .projects-carousel .project-card {\n    flex-basis: min(19rem, calc(100vw - 5.75rem));\n    min-width: min(19rem, calc(100vw - 5.75rem));\n    max-width: min(19rem, calc(100vw - 5.75rem));\n  }\n}\n\n/* Cartes projets : hauteur au contenu, visuel plus compact */\n.portfolio-page .cv-projects-fullwidth.projects-showcase .project-image {\n  height: 152px;\n  flex-shrink: 0;\n}\n\n.portfolio-page .cv-projects-fullwidth.projects-showcase .project-content {\n  flex: 0 1 auto;\n  padding: 0.85rem 1rem 1.05rem;\n  display: flex;\n  flex-direction: column;\n}\n\n.portfolio-page .cv-projects-fullwidth.projects-showcase .project-content h4 {\n  font-size: 1.12rem;\n  margin-bottom: 0.45rem;\n}\n\n.portfolio-page .cv-projects-fullwidth.projects-showcase .project-content p {\n  font-size: 0.86rem;\n  line-height: 1.5;\n  margin-bottom: 0.6rem;\n}\n\n.portfolio-page .cv-projects-fullwidth.projects-showcase .project-highlights {\n  margin-bottom: 0.45rem;\n}\n\n.portfolio-page .cv-projects-fullwidth.projects-showcase .project-tags {\n  margin-bottom: 0.5rem;\n}\n\n.portfolio-page .cv-projects-fullwidth.projects-showcase .project-link {\n  margin-top: 0;\n  align-self: flex-start;\n}\n\n@media (max-width: 520px) {\n  .portfolio-page .projects-carousel-arrow {\n    width: 2.1rem;\n    height: 2.1rem;\n  }\n\n  .portfolio-page .projects-carousel-arrow svg {\n    width: 1.2rem;\n    height: 1.2rem;\n  }\n}\n\n/* Parcours */\n.portfolio-page .cv-theme-parcours-band {\n  background: linear-gradient(180deg, var(--pf-zone-b) 0%, #f8fafc 45%);\n  padding: 2.5rem 0 3rem;\n  border-bottom: 1px solid #e9d5ff;\n}\n\n.cv-theme-parcours-band .cv-band-inner {\n  max-width: 72rem;\n}\n\n.portfolio-page .cv-columns-full {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 0;\n  align-items: start;\n  position: relative;\n  background: #fff;\n  border-radius: 14px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 8px 30px rgba(99, 102, 241, 0.08), 0 2px 8px rgba(15, 23, 42, 0.04);\n  overflow: hidden;\n  max-width: 100%;\n}\n\n.portfolio-page .cv-columns-full::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 4px;\n  background: linear-gradient(180deg, #2563eb, #7c3aed);\n  border-radius: 14px 0 0 14px;\n  z-index: 1;\n  pointer-events: none;\n}\n\n@media (min-width: 56rem) {\n  .portfolio-page .cv-columns-full {\n    grid-template-columns: minmax(0, 16rem) minmax(0, 1fr);\n  }\n}\n\n@media (min-width: 64rem) {\n  .portfolio-page .cv-columns-full {\n    grid-template-columns: minmax(0, 17.5rem) minmax(0, 1fr);\n  }\n}\n\n.cv-theme-parcours-band .cv-sidebar {\n  background: #f8fafc;\n  border-right: 1px solid #e2e8f0;\n}\n\n.cv-theme-parcours-band .cv-main {\n  background: #fff;\n  min-width: 0;\n}\n\n/* Formation */\n.portfolio-page .cv-theme-formation-band {\n  background: linear-gradient(180deg, var(--pf-zone-c) 0%, #fffbeb 35%, #f8fafc 100%);\n  padding: 2.5rem 0 3.5rem;\n  border-top: 1px solid #fed7aa;\n}\n\n.cv-band-formation {\n  width: 100%;\n  max-width: 72rem;\n  margin: 0 auto;\n  padding: 0 1.25rem;\n  box-sizing: border-box;\n}\n\n.cv-band-formation .cv-section-formation-only {\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.06);\n  padding: 1.75rem 1.5rem 2rem !important;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.portfolio-page .cv-theme-formation-band .cv-section-title {\n  color: #0f172a;\n  border-bottom-color: var(--pf-accent);\n}\n\n.portfolio-page .cv-theme-formation-band .cv-education > li {\n  border-bottom-color: #f1f5f9;\n}\n\n.portfolio-page .cv-theme-formation-band .cv-edu-years {\n  color: var(--pf-accent);\n}\n\n.cv-sidebar {\n  background: #f8fafc;\n  border-right: 1px solid #e2e8f0;\n  padding: 1.5rem 1.15rem 1.75rem;\n  font-size: 0.8125rem;\n  min-width: 0;\n}\n\n.cv-side-section {\n  margin-bottom: 1.5rem;\n}\n\n.portfolio-page .cv-sidebar .cv-side-section {\n  margin-bottom: 2rem;\n}\n\n.cv-side-section:last-child {\n  margin-bottom: 0;\n}\n\n.portfolio-page .cv-sidebar .cv-side-section:last-child {\n  margin-bottom: 0;\n}\n\n.portfolio-page .cv-sidebar .cv-side-section--extra-top {\n  padding-top: 1rem;\n}\n\n.cv-side-sub {\n  margin: 0.75rem 0 0.35rem;\n  font-size: 0.68rem;\n  font-weight: 600;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.cv-side-sub:first-of-type {\n  margin-top: 0;\n}\n\n.portfolio-page .cv-sidebar .cv-side-sub {\n  margin: 1rem 0 0.45rem;\n}\n\n.portfolio-page .cv-sidebar .cv-side-sub:first-of-type {\n  margin-top: 0.35rem;\n}\n\n.cv-chip-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n}\n\n.cv-chip-list li {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  padding: 0.2rem 0.45rem;\n  border-radius: 6px;\n  font-size: 0.72rem;\n  color: #334155;\n}\n\n.cv-chip-list-dense li {\n  font-size: 0.68rem;\n}\n\n.cv-side-text {\n  margin: 0;\n  color: #475569;\n  line-height: 1.55;\n  font-size: 0.8rem;\n}\n\n.portfolio-page .cv-sidebar .cv-side-infra-lead {\n  margin-bottom: 0.45rem;\n}\n\n.portfolio-page .cv-sidebar .cv-side-cert-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  font-size: 0.8rem;\n  color: #475569;\n  line-height: 1.45;\n}\n\n.cv-main {\n  padding: 1.5rem 1.25rem 2rem;\n  text-align: left;\n  min-width: 0;\n}\n\n.cv-section {\n  margin-bottom: 1.5rem;\n}\n\n.cv-section:last-child {\n  margin-bottom: 0;\n}\n\n.portfolio-page .cv-section-title {\n  margin: 0 0 0.75rem;\n  padding-bottom: 0.35rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.11em;\n  color: #0f172a;\n  border-bottom: 2px solid var(--pf-accent);\n}\n\n.portfolio-page .cv-section-title--with-suffix {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 0.45rem 0.65rem;\n}\n\n.portfolio-page .cv-section-title-suffix {\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: none;\n  color: #64748b;\n}\n\n.cv-job {\n  margin-bottom: 1.35rem;\n  padding-bottom: 1.35rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.cv-job:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.cv-job--with-logo {\n  --cv-job-logo-size: 2.5rem;\n  --cv-job-logo-gap: 0.65rem;\n}\n\n.cv-job-block {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--cv-job-logo-gap);\n}\n\n.cv-job-logo {\n  width: var(--cv-job-logo-size);\n  height: var(--cv-job-logo-size);\n  flex-shrink: 0;\n  object-fit: contain;\n  border-radius: 6px;\n  background: #fff;\n  box-shadow: 0 0 0 1px rgba(15, 23, 42, 0.08);\n}\n\n.cv-job-block-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.cv-job-title-row {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 0.5rem 0.85rem;\n  margin-bottom: 0.1rem;\n}\n\n.cv-job-title-row .cv-job-title {\n  flex: 1;\n  min-width: 0;\n}\n\n.cv-job-title {\n  margin: 0;\n  font-size: 0.98rem;\n  font-weight: 600;\n  color: #1a202c;\n}\n\n.cv-job-org {\n  margin: 0.15rem 0 0;\n  font-size: 0.84rem;\n  font-weight: 500;\n  color: #475569;\n}\n\n.cv-job-loc {\n  margin: 0.1rem 0 0;\n  font-size: 0.8rem;\n  color: #64748b;\n}\n\n.portfolio-page .cv-job-dates {\n  flex-shrink: 0;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--pf-accent);\n  white-space: nowrap;\n}\n\n.cv-bullets {\n  margin: 0.5rem 0 0;\n  padding-left: 1.1rem;\n  color: #4a5568;\n  font-size: 0.84rem;\n  line-height: 1.55;\n}\n\n.cv-job-block-text .cv-bullets {\n  margin-top: 0.55rem;\n}\n\n.cv-bullets li {\n  margin-bottom: 0.3rem;\n}\n\n.cv-education {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.cv-education > li {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 0.45rem 1rem;\n  padding: 0.6rem 0;\n  border-bottom: 1px solid #f1f5f9;\n  font-size: 0.84rem;\n}\n\n.cv-education > li:last-child {\n  border-bottom: none;\n}\n\n.cv-edu-main {\n  display: flex;\n  flex-direction: column;\n  gap: 0.12rem;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.cv-edu-main strong {\n  color: #1a202c;\n  font-weight: 600;\n}\n\n.cv-edu-main span {\n  color: #64748b;\n  font-size: 0.8rem;\n}\n\n.portfolio-page .cv-edu-years {\n  flex-shrink: 0;\n  font-weight: 600;\n  color: var(--pf-accent);\n  font-size: 0.78rem;\n}\n\n/* Footer discret + marge basse (encoche / home indicator) */\n.portfolio-footer {\n  text-align: center;\n  padding: 1.1rem 1rem calc(1rem + env(safe-area-inset-bottom, 12px));\n  font-size: 0.72rem;\n  color: #94a3b8;\n  letter-spacing: 0.02em;\n  border-top: 1px solid #e2e8f0;\n  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);\n}\n\n.portfolio-footer p {\n  margin: 0;\n}\n\n.portfolio-footer-link {\n  color: #64748b;\n  text-decoration: none;\n}\n\n.portfolio-footer-link:hover {\n  color: var(--pf-accent);\n  text-decoration: underline;\n}\n\n@media (max-width: 768px) {\n  .portfolio-hero.cv-theme-intro {\n    padding: 0.65rem 0 0.85rem;\n  }\n\n  .portfolio-page .portfolio-hero .cv-header {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .portfolio-page .portfolio-hero .cv-header.cv-header-hero {\n    padding: 0;\n  }\n\n  .portfolio-page .portfolio-hero .cv-contact:not(.portfolio-hero-meta) {\n    text-align: center;\n    width: 100%;\n  }\n\n  .portfolio-page .portfolio-hero .cv-contact:not(.portfolio-hero-meta) li {\n    justify-content: center;\n  }\n\n  .portfolio-page .portfolio-hero .cv-contact:not(.portfolio-hero-meta) .cv-contact-block-text {\n    align-items: center;\n    text-align: center;\n  }\n\n  .cv-theme-parcours-band .cv-sidebar {\n    border-right: none;\n    border-bottom: 1px solid #e2e8f0;\n  }\n\n  .cv-main {\n    padding: 1.25rem 1rem 1.75rem;\n  }\n\n  .cv-job-title-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.35rem;\n  }\n\n  .portfolio-page .cv-job-dates {\n    white-space: normal;\n  }\n}\n\n@media print {\n  .App.cv-page-root.portfolio-page {\n    background: #fff;\n    overflow: visible;\n  }\n\n  .cv-main-wrap {\n    background: #fff;\n  }\n\n  .cv-theme-band,\n  .portfolio-hero.cv-theme-intro {\n    background: #fff !important;\n    min-height: auto;\n    border: none;\n    box-shadow: none;\n  }\n\n  .cv-job {\n    break-inside: avoid;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
